import { TableSearchListConfig } from "./types";

const initialConfig: TableSearchListConfig["config"] = {
  search: {
    enabled: true,
    placeholder: "Search",
    searchUrl: "",
  },
  table: {
    columnDefs: [],
    default_sort_accessor: "",
    default_sort_order: "desc",
  },
  more_details_dialog: {
    enabled: true,
    title: "More Details",
    content: {
      section_columns: [],
      description: "Description",
    },
  },
};

export { initialConfig };
